<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import Grid from '../Shared/Grid'
const moment = require('moment')

export default {
  name: 'StudentClassesTab',
  props: ['studentForm', 'validation'],
  components: {
    Grid
  },
  data () {
    return {
      moment: moment,
      module: this.$route.meta.module,
      columnOptions: [
        { field: 'CLASS_ID', name: 'CLASS_ID', label: 'Class ID', sortable: false, filterable: false, filter: '', type: 'string' },
        { field: 'AFFILIATE_CODE', name: 'AFFILIATE_CODE', label: 'Agency', sortable: false, filterable: false, filter: '', type: 'string' },
        { field: 'CLASS_START_DATE', name: 'CLASS_START_DATE', label: 'Class Start Date', sortable: true, filterable: true, filter: { start: null, end: null },  type: 'date' },
        { field: 'CLASS_END_DATE', name: 'CLASS_END_DATE', label: 'Class End Date', sortable: true, filterable: true, filter: { start: null, end: null },  type: 'date' },
        { field: 'STATUS', name: 'STATUS', label: 'Status', sortable: false, filterable: false, filter: '', type: 'string' }
      ]
    }
  },
  computed: {
    ...mapState('students', {
      classes: state => state.studentClassList,
    }),
    ...mapGetters('students', [
    ])
  },
  methods: {
    ...mapActions('students', [
      'fetchStudentClasses'
    ]),
    ...mapMutations('students', [
    ]),
    ...mapActions('classes', [
      'one'
    ]),
    async select (e, session_id) {
      let vm = this
      let id = e.CLASS_ID
      vm.one({
        id: e.CLASS_ID,
        mode: 'edit'
      })
        
    }
  }
}
</script>

<template>
  <div class="fit">
    <Grid
      :module="module"
      :data="classes"
      :columns="columnOptions"
      :onRequest="fetchStudentClasses"
      :onLaunch="select">
      <template slot="col-item-status" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
          class="label"
          :class="{
            'blue'  : props.value == 'SCHEDULED',
            'green' : props.value =='ACTIVE' || props.value =='APPROVED' || props.value == 'COMPLETED',
            'purple': props.value == 'PROCESSED',
            'red'   : props.value =='CANCELLED',
            'yellow': props.value =='HELD'
          }">
          {{props.value}}
        </div>
      </template>
    </Grid>
  </div>
</template>

<style>
</style>
